module.exports = __webpack_public_path__ + "img/LOGO2.a3da6100.png";